import { combineReducers } from "redux";
import { CHANGE_CITY_STATUS_REQUEST, CHANGE_CITY_WEIGHT_REQUEST, FETCH_CITIES_REQUEST } from "./constants";
import { arrayToObject } from "../../utils/arrayToObject";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action, CityItems } from "./types";

function items(state: CityItems = {}, action: Action): CityItems {
  switch (action.type) {
    case getSuccessActionType(FETCH_CITIES_REQUEST):
      return arrayToObject(action.payload);

    case CHANGE_CITY_STATUS_REQUEST:
    case CHANGE_CITY_WEIGHT_REQUEST:
      return { ...state, [action.data.cityId]: { ...state[action.data.cityId], isFetching: true } };

    case getSuccessActionType(CHANGE_CITY_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_CITY_WEIGHT_REQUEST):
      return { ...state, [action.data.cityId]: { ...action.payload, isFetching: false } };

    case getFailureActionType(CHANGE_CITY_STATUS_REQUEST):
    case getFailureActionType(CHANGE_CITY_WEIGHT_REQUEST):
      return { ...state, [action.data.cityId]: { ...state[action.data.cityId], isFetching: false } };

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action) {
  switch (action.type) {
    case FETCH_CITIES_REQUEST:
      return true;

    case getSuccessActionType(FETCH_CITIES_REQUEST):
    case getFailureActionType(FETCH_CITIES_REQUEST):
      return false;
    default:
      return state;
  }
}

export const cities = combineReducers({ items, isFetching });
